{
  "name": "@sveltia/cms",
  "version": "0.227.0",
  "description": "Sveltia CMS is a modern, lightweight, Git-based headless content management system.",
  "keywords": [
    "svelte",
    "cms",
    "content-management-system"
  ],
  "homepage": "https://sveltiacms.app/en/",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/sveltia/sveltia-cms.git"
  },
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/kyoshino"
  },
  "license": "MIT",
  "author": {
    "name": "Kohei Yoshino",
    "url": "https://github.com/kyoshino"
  },
  "type": "module",
  "scripts": {
    "build": "vite build",
    "build:watch": "vite build --watch",
    "check": "pnpm run --no-bail '/^check:.*/'",
    "check:audit": "pnpm audit --ignore-registry-errors",
    "check:cspell": "cspell --no-progress",
    "check:eslint": "eslint .",
    "check:imports": "node scripts/find-unused-imports.js",
    "check:l10n": "node scripts/check-locales.js",
    "check:oxlint": "oxlint .",
    "check:prettier": "prettier --check .",
    "check:stylelint": "stylelint '**/*.{css,scss,svelte}'",
    "check:svelte": "svelte-check",
    "dev": "vite",
    "format": "prettier --write .",
    "prepublishOnly": "vite build",
    "preview": "vite preview",
    "test": "NODE_OPTIONS=--no-experimental-webstorage vitest run",
    "test:components": "NODE_OPTIONS=--no-experimental-webstorage vitest run --project browser",
    "test:components:coverage": "NODE_OPTIONS=--no-experimental-webstorage vitest run --coverage --project browser --coverage.include='src/lib/components/**/*.svelte' --coverage.thresholds.branches=98.4",
    "test:e2e": "playwright test -c e2e/playwright.config.js",
    "test:e2e:ui": "playwright test -c e2e/playwright.config.js --ui",
    "test:unit": "NODE_OPTIONS=--no-experimental-webstorage vitest run --project unit",
    "test:unit:coverage": "NODE_OPTIONS=--no-experimental-webstorage vitest run --coverage --project unit",
    "test:watch": "NODE_OPTIONS=--no-experimental-webstorage vitest"
  },
  "dependencies": {
    "@cfworker/json-schema": "^4.1.1",
    "@discourse/heic": "^1.0.0",
    "@jsquash/webp": "^1.5.0",
    "@lexical/markdown": "^0.52.0",
    "@sindresorhus/transliterate": "^2.3.1",
    "@sveltia/i18n": "^1.4.0",
    "@sveltia/ui": "^0.78.4",
    "@sveltia/utils": "^0.12.2",
    "create-react-class": "^15.7.0",
    "dayjs": "^1.11.23",
    "deepmerge": "^4.3.1",
    "exifr": "^7.1.3",
    "fast-deep-equal": "^3.1.3",
    "flat": "^6.0.1",
    "immutable": "^5.1.9",
    "isomorphic-dompurify": "^4.4.0",
    "leaflet": "^1.9.4",
    "lexical": "^0.52.0",
    "marked": "^18.0.14",
    "marked-bidi": "^1.0.15",
    "mime": "^4.1.0",
    "parse-entities": "^4.0.2",
    "pdfjs-dist": "^6.3.289",
    "qrcode": "^1.5.4",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "sanitize-filename": "^1.6.4",
    "smol-toml": "^1.9.0",
    "svgo": "^4.1.0",
    "terra-draw": "^1.35.0",
    "terra-draw-leaflet-adapter": "1.0.3",
    "turndown": "^7.2.4",
    "yaml": "^2.9.1"
  },
  "devDependencies": {
    "@playwright/test": "^1.63.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@sveltejs/vite-plugin-svelte": "^7.3.1",
    "@types/leaflet": "^1.9.22",
    "@types/node": "^26.6.3",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitest/browser-playwright": "^5.0.2",
    "@vitest/coverage-v8": "^5.0.2",
    "cspell": "^10.3.6",
    "eslint": "^9.39.5",
    "eslint-config-airbnb-extended": "^3.2.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jsdoc": "^65.0.0",
    "eslint-plugin-package-json": "^1.10.1",
    "eslint-plugin-svelte": "^3.23.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.12.0",
    "happy-dom": "^20.14.5",
    "messageformat": "^4.0.0",
    "oxlint": "^1.86.0",
    "playwright": "^1.63.0",
    "postcss-html": "^2.0.0",
    "prettier": "^3.9.9",
    "prettier-plugin-svelte": "^4.1.1",
    "sonda": "^0.14.0",
    "stylelint": "^17.15.0",
    "stylelint-config-recommended": "^18.0.0",
    "svelte": "^5.57.1",
    "svelte-check": "^4.7.6",
    "ts-json-schema-generator": "^2.9.0",
    "typescript": "^6.0.3",
    "vite": "^8.3.1",
    "vitest": "^5.0.2",
    "vitest-browser-svelte": "^3.1.0"
  },
  "publishConfig": {
    "directory": "package"
  }
}
